import './FilterTags.scss';
import React from 'react';
import closeIconPath from '@icons/close-white-small.svg'
import classnames from 'classnames';
import {useNormalizedTransformer} from "../../hooks/useNormalizedTransformer";

const FilterTags = ({
    tags,
    onRemoveFilter,
    classes,
}) => {
    const normalizeTag = useNormalizedTransformer([
        {
            search: /^.*?:/g,
            replace: ''
        },
        {
            search: /[_-]+/g,
            replace: ' '
        }
    ]);

    return (
        (
            <div
                className={classnames('b-filter-tags', classes)}
            >
                <div className="b-filter-tags-wrapper">
                    {tags.map((tag, index) => (
                        <div className="b-filter-tag" key={index}>
                            {normalizeTag(tag.title)}
                            <button
                                className="b-filter-tag-remove-button"
                                onClick={onRemoveFilter.bind(this, tag.title, index, tag.key)}
                                data-testid={'remove tag ' + tag.title}
                            >
                                <img src={closeIconPath} alt="close-icon" />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        )
    );
}

export default FilterTags;
